import { render, staticRenderFns } from "./cardViewer.vue?vue&type=template&id=d8198c1c&scoped=true"
import script from "./cardViewer.vue?vue&type=script&lang=js"
export * from "./cardViewer.vue?vue&type=script&lang=js"
import style0 from "./cardViewer.vue?vue&type=style&index=0&id=d8198c1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8198c1c",
  null
  
)

export default component.exports